"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNITS = exports.TRANSFORM = exports.METER_TO_KILOMETER = exports.METER_TO_FEET = exports.KILOMETER_TO_METER = exports.KILOMETER_TO_FEET = exports.GEO_ALGORITHMS = exports.FEET_TO_METER = exports.FEET_TO_KILOMETER = void 0;
const UNITS = {
  DISTANCE: {
    FEET: 'feet',
    METERS: 'meters',
    KILOMETERS: 'kilometers'
  }
};
exports.UNITS = UNITS;
const GEO_ALGORITHMS = {
  TURF: 'turf',
  GEOD: 'geod'
};
exports.GEO_ALGORITHMS = GEO_ALGORITHMS;
const {
  FEET,
  METERS,
  KILOMETERS
} = UNITS.DISTANCE;
const METER_TO_FEET = 3.28084;
exports.METER_TO_FEET = METER_TO_FEET;
const KILOMETER_TO_METER = 1000;
exports.KILOMETER_TO_METER = KILOMETER_TO_METER;
const KILOMETER_TO_FEET = KILOMETER_TO_METER * METER_TO_FEET;
exports.KILOMETER_TO_FEET = KILOMETER_TO_FEET;
const FEET_TO_METER = 0.3048;
exports.FEET_TO_METER = FEET_TO_METER;
const METER_TO_KILOMETER = 0.001;
exports.METER_TO_KILOMETER = METER_TO_KILOMETER;
const FEET_TO_KILOMETER = 0.0003048; // Cannot multiply the above two variables without getting weird JS rounding issues
exports.FEET_TO_KILOMETER = FEET_TO_KILOMETER;
const TRANSFORM = {
  FROM: {
    [KILOMETERS]: {
      TO: {
        [FEET]: KILOMETER_TO_FEET,
        [METERS]: KILOMETER_TO_METER,
        [KILOMETERS]: 1
      }
    },
    [FEET]: {
      TO: {
        [KILOMETERS]: FEET_TO_KILOMETER,
        [METERS]: FEET_TO_METER,
        [FEET]: 1
      }
    },
    [METERS]: {
      TO: {
        [FEET]: METER_TO_FEET,
        [KILOMETERS]: METER_TO_KILOMETER,
        [METERS]: 1
      }
    }
  }
};
exports.TRANSFORM = TRANSFORM;